import React from 'react';
import { View, StyleSheet, Text, ViewStyle } from 'react-native';

import colors from 'shared/modules/common/constants/colors';
import typography from 'shared/modules/common/constants/typography';

type Props = {
  total: string;
  containerStyle?: ViewStyle;
};

export default function CreditTotal({ total, containerStyle }: Props) {
  return (
    <View style={[styles.container, containerStyle]}>
      <Text style={styles.label}>合計</Text>
      <Text style={styles.value}>{total}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 24,
  },
  label: {
    ...typography.title03,
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 24,
    color: colors.greyDark,
  },
  value: {
    ...typography.title03,
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 24,
    textAlign: 'right',
    color: colors.blackMedium,
  },
});
